/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `UserStatusCode*`'s.
 */
export type UserStatusCode = UserStatusCodePending | UserStatusCodeActive | UserStatusCodeDisabled;

/**
 * Initial status for all users, means invitation is not accepted yet.
 * @export
 */
export type UserStatusCodePending = typeof USER_STATUS_CODE_PENDING;

/**
 * The invitation is accepted and the user is active.
 * @export
 */
export type UserStatusCodeActive = typeof USER_STATUS_CODE_ACTIVE;

/**
 * User is deactivated.
 * @export
 */
export type UserStatusCodeDisabled = typeof USER_STATUS_CODE_DISABLED;

/**
 * User has a pending invitation.
 * @export
 */
export const USER_STATUS_CODE_PENDING = `Pending`;

/**
 * User has accepted the invitation and is active.
 * @export
 */
export const USER_STATUS_CODE_ACTIVE = `Active`;

/**
 * User has been deleted, or deactivated.
 * @export
 */
export const USER_STATUS_CODE_DISABLED = `Disabled`;
